import { isProd }  from '@/commons/utils';

const CONSENT_API_KEY = isProd ? '02d83a98-b875-4588-b694-ceff0e0dd87c' : 'b542bb45-8028-4268-b5d1-fe25ce7f9fdf';
const country = cube.env.country;
const rules = Object.assign(
  $.validator.cubeOptions,
  { ignore: '' }
);

let form;
let subscriptions;

export const init = () => {
  cube.ajax.post('api-proxy/consent_management/external/v1/user', {
    'httpMethod': 'GET',
    'queryParameters': {'country_code': country, 'tags': 'loyalty'},
    'httpHeaders': {'X-Api-Key': CONSENT_API_KEY}
  })
    .onSuccess((response) => {
      subscriptions = response.responseTO.data.responseBody.events[0].consents.purposes;
      if(subscriptions[0].enabled === true){
        $('#isSubscribed').show();
        $('#isNotSubscribed').hide();
      }else{
        $('#isSubscribed').hide();
        $('#isNotSubscribed').show();
      }
    }).call();

  form = cube.$id('loyalty-benefits-form');
  $(form).validate(rules);

  const buttons = cube.$$('#subscribe-button, #loyalty-benefits-modal-confirmation-button');
  if (buttons.length){
    buttons.on('click', setLoyaltySubscription);
  }
  const modalButtons = cube.$$('#unsubscribe-button, #loyalty-benefits-modal-cancel-button');
  if (modalButtons)
    modalButtons.on('click', toggleModal);
};


/**
 * Open or close the unsubscription modal
 *
 * @param {Event} e
 */
const toggleModal = e => {
  e.preventDefault();
  const modal = cube.$id('loyalty-benefits-modal');
  modal.checked = !modal.checked;
};


/**
 * Update the customer subscrition to the membership program
 *
 * @param {Event} e
 */
function setLoyaltySubscription (e) {
  e.preventDefault();
  const message = (this.id === 'subscribe-button')
    ? 'account.loyalty.subscription.success'
    : 'account.loyalty.unsubscription.success';

  let param;
  if( e.target.id === 'loyalty-benefits-modal-confirmation-button'){
    param = false;
  }else{
    param = true;
  }

  const newData = {
    consents: {
      channels: [],
      purposes: [{'id': subscriptions[0].id, 'enabled': param}]
    }
  };
  cube.ajax.post('api-proxy/consent_management/external/v1/events', {
    'httpMethod': 'POST',
    'jsonBody': newData,
    'httpHeaders': {'X-Api-Key': CONSENT_API_KEY, 'application_country_code': country, 'user_language': country}
  }).call();

  if(cube.$id('loyalty-benefits-modal')){
    toggleModal(e);
  }
  cube.alert.success(window.Messages(message));
  window.location.reload();
};



// WEBPACK FOOTER //
// ./src/customer/account/account-membership-benefits.js